export const SERVICE = {
  STUDENTID: '톡학생증',
  DIGITALCARD: '톡디지털카드',
  ZIKZANG: '톡사원증',
  LOCAL_CARD: '동네카드',
  CERT_CARD: '자격카드',
  TEEN_CARD: '틴카드'
} as const;

export type Service = (typeof SERVICE)[keyof typeof SERVICE];
